const VOLTRAN_ADVERTISEMENT_EVENT_NAME = 'storefront.voltran.advertisement';

const FACET_NAMES = {
  CATEGORY: 'Kategori',
  BRAND: 'Marka',
  RATING: 'puan',
  FILTERS: 'filtreler',
}

export {
  VOLTRAN_ADVERTISEMENT_EVENT_NAME,
  FACET_NAMES
}
